import controller from './renewal-message.controller.js';

let renewalMessageModule = angular.module('renewal-message', [])

    .directive('renewalMessage', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {
                chapterId: '@'
            },
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default renewalMessageModule;



// WEBPACK FOOTER //
// ./src/app/angular/renewal-message/renewal-message.js